<template>
  <div class="box">
    <arnergy-loader v-if="showLoading" />
    <h3>Update Invoice</h3>
    <hr />

    <div class="form-item">
      <label class="label">Payment Reference</label>
      <input class="input" v-model="formParams.paymentRef" required />
      <small v-if="formErrors.paymentRef" class="error">
        {{ formErrors.paymentRef }}
      </small>
    </div>

    <div class="form-item">
      <label class="label">Payment Type</label>
      <select
        class="input-select"
        value="paymentType"
        v-model="formParams.paymentType"
      >
        <option
          v-for="(optionVal, index) in ['Cash', 'Bank Transfer']"
          :key="index"
          :label="optionVal"
          :value="optionVal"
        >
        </option> </select
      ><small v-if="formErrors.paymentType" class="error">
        {{ formErrors.paymentType }}
      </small>
    </div>
    <b-button @click="doUpdate" variant="primary">Update</b-button>
  </div>
</template>

<script>
import ArnergyLoader from "./ArnergyLoader";
export default {
  name: "EditInvoice",
  components: {
    "arnergy-loader": ArnergyLoader
  },
  props: {
    invoiceId: { required: true },
    options: {}
  },
  data() {
    return {
      formParams: {
        paymentType: "",
        paymentRef: ""
      },
      formErrors: {
        paymentType: "",
        paymentRef: ""
      },
      showLoading: false
    };
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },

  mounted() {},
  methods: {
    selectOption(event) {
      console.log(event);
    },
    doUpdate(e) {
      e.preventDefault();
      this.formErrors = this._doValidate();

      if (Object.keys(this.formErrors).length > 0) return;

      const data = {
        ...this.formParams,
        paymentType: this.formParams.paymentType,
        paymentRef: this.formParams.paymentRef,
        invoiceID: this.invoiceId
      };

      const HTTP = this.$httpUtils.instance;

      this.showLoading = true;
      HTTP.post("/invoices/status/update", data)
        .then(res => {
          this.showLoading = false;
          this.showSuccessMsg({ message: "Invoice Successfully updated" });
          //@todo: do something more interesting than reload
          window.location.reload();
        })
        .catch(e => {
          const errorMessage =
            e.response.data.error.message ||
            "Something went wrong, please try again.";
          this.showLoading = false;
          this.showErrorMsg({ message: errorMessage });
        });
    },

    _doValidate() {
      const formErrors = [];

      for (let [field, value] of Object.entries(this.formParams)) {
        value = value + "";
        if (value !== "null" && value !== Number.isInteger(value)) {
          value = value.trim();
        }

        switch (field) {
          case "paymentType":
            if (value === "null" || value === "") {
              formErrors[field] = "paymentType cannot be empty.";
            }
            break;
          case "paymentRef":
            if (value === "null" || value === "") {
              formErrors[field] = "paymentRef cannot be empty.";
            }
            break;
          default:
            break;
        }
      }
      return formErrors;
    }
  }
};
</script>

<style lang="scss" scoped>
.form-item {
  margin: 10px 0;
}

.input-select {
  border: 1px solid #cccccc;
  width: 100%;
  padding: 10px 20px;
  height: 50px;
}
label {
  margin-bottom: 10px;
  font-size: 14px;
  padding: 0;
  font-weight: bold;
  display: block;
  color: black;
  text-align: left;
}
.box {
  position: relative;
}

.input {
  border: 1px solid #cccccc !important;
  width: 100%;
  padding: 10px 20px;
  height: 50px;
  display: block;
}

.error {
  color: red;
}
//
</style>



// WEBPACK FOOTER //
// src/components/pages/kitchen/EditInvoice.vue